<!-- Banner waehrend Support-Impersonation: zeigt Support-Hinweis, CRM-Mitarbeiter,
     Live-Countdown der 60-min-Session, Button zum sauberen Beenden. -->
<template>
  <div class="imp-banner">
    <span class="imp-banner-icon">🛡</span>
    <span class="imp-banner-text">
      <strong>Support-Modus</strong> · {{ who }}
    </span>
    <span class="imp-banner-time">{{ remaining }}</span>
    <button class="imp-banner-btn" @click="end">Support-Session beenden</button>
  </div>
</template>

<script>
const { formatRemaining } = require('@/modules/util/formatRemaining');

export default {
  data() {
    return { now: Date.now(), timer: null };
  },
  computed: {
    who() {
      return this.$store.state.user?.impersonatedBy || 'Betreiber';
    },
    expiresAtMs() {
      const v = this.$store.state.user?.impersonationExpiresAt;
      return v ? new Date(v).getTime() : 0;
    },
    remaining() {
      return formatRemaining(this.expiresAtMs - this.now);
    },
  },
  methods: {
    tick() {
      this.now = Date.now();
      if (this.expiresAtMs && this.expiresAtMs - this.now <= 0) {
        this.end();
      }
    },
    async end() {
      // serverseitig beenden (best effort), dann lokal hart aufraeumen
      try { await this.apiRequest('DELETE', '/account/impersonation', null, false); } catch (e) { /* fail-safe: trotzdem lokal aufraеumen */ }
      this.destroySession();        // entfernt Cookie + bumpt reevaluateLogin (konsistent mit regulaerem Logout)
      this.$store.commit('clearAccount');
      this.$router.push('/login');
    },
  },
  mounted() {
    this.timer = setInterval(this.tick, 1000);
  },
  unmounted() {
    if (this.timer) clearInterval(this.timer);
  },
};
</script>

<style scoped>
.imp-banner {
  display: flex; align-items: center; gap: 12px;
  background: #b45309; color: #fff;
  padding: 8px 16px; font-size: 14px;
}
.imp-banner-icon { font-size: 16px; }
.imp-banner-text { flex: 0 0 auto; }
.imp-banner-time {
  font-variant-numeric: tabular-nums; font-weight: 700;
  margin-left: auto; background: rgba(0,0,0,.2);
  padding: 2px 8px; border-radius: 4px;
}
.imp-banner-btn {
  background: #fff; color: #b45309; border: none; border-radius: 4px;
  padding: 5px 12px; font-size: 13px; font-weight: 600; cursor: pointer;
}
.imp-banner-btn:hover { opacity: .9; }
</style>
